<template>
    <v-row align="start"
           justify="center"
    >
        <v-col v-if="introCard && introCard.id" cols="12" sm="10" xl="10">
            <Card :id="introCard.id"
                  :key="introCard.name+id"
            />
        </v-col>

        <v-col cols="12" sm="10" xl="10" v-if="trainingCards">
            <ul class="TrainingGrid">
                <li class="TrainingGrid__item" v-for="(card, id) in trainingCards" :key="id">
                    <Card :id="card.id"
                          :key="card.name+id"
                    />
                </li>
            </ul>
        </v-col>
    </v-row>
</template>

<script>
import Card from '@/views/Public/Card/Card';

export default {
    components: { Card },
    props: {
        cards: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            introCard: [],
            trainingCards: [],
        };
    },

    mounted() {
        this.pullIntroCard();
        this.setTrainingCards();
    },

    methods: {
        pullIntroCard() {
            this.introCard = this.cards.find(obj => obj.type === 'introductory');
        },

        setTrainingCards() {
            this.trainingCards = this.cards.filter(card => card.type !== 'introductory');
        }
    }
};
</script>
